import {
  HelpdeskTaskPersonalAccountFormDto,
  type HelpdeskTaskPersonalAccountFormInterface
} from '@zaoblako/shared/modules/helpdesk/dto/task/helpdesk-task-personal-account-form.dto'
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';

import * as yup from 'yup';

/** Helpdesk task for personal account create API request body */
export interface HelpdeskTaskPersonalAccountCreateInterface extends HelpdeskTaskPersonalAccountFormInterface {
  /** Files to attach */
  files?: OnlyIdRequiredInterface<FileFindInterface>[];
}

/** Helpdesk task for personal account create API request body - DTO schema */
export const HelpdeskTaskPersonalAccountCreateDto = SerdeDtoClass.from<HelpdeskTaskPersonalAccountFormInterface, HelpdeskTaskPersonalAccountCreateInterface>(
  HelpdeskTaskPersonalAccountFormDto,
  HelpdeskDtoKeyEnum.HELPDESK_TASK_PERSONAL_ACCOUNT_CREATE_DTO,
  {
    files: {
      optional: true,
      label: 'Прикрепленные файлы',
      serializer: yup.array(entityLikeSchema),
    },
  },
);
